import DeleteProductBinIcon from './DeleteProductBinIcon';

export default DeleteProductBinIcon;
